import { customAxios, FDV_URL } from '../constants';
import { FETCH_RESPONSABLES } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchResponsables(codigo = '', nombreCompleto = '') {
  const config = {
    params: {
      tipUsuario: codigo,
      nombreCompleto: nombreCompleto
    },
  };

  const request = customAxios.get(`${FDV_URL}/autorizacion-excepcional/usuarios-solicitud`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_RESPONSABLES,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Responsables.js